import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-off-the-plan',
  templateUrl: './off-the-plan.component.html',
  styleUrls: ['./off-the-plan.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OffThePlanComponent {
  errorWarningData: any = {};
  @Input() MatterConveyancingDetailsForm: FormGroup;
  propertyTypeLookupsData: any[];
  sub: Subscription;

  @Input() toolTipList: any;
  toolTipPostion = 'above';
  @Input() testBool;
  constructor(private datepipe: DatePipe) {}

  CommanDatePickerClick(type: string, event: MatDatepickerInputEvent<Date>, formControlVar) {
    this.MatterConveyancingDetailsForm.controls[formControlVar].setValue(
      this.datepipe.transform(event.value, 'dd/MM/yyyy'),
    );
  }
}
